import { Text, type TextProps } from '@spotify-internal/encore-web';
import { Skeleton } from '@spotify/confidence-core-react';

import { usePageTitle } from './utils';

export type PageTitleProps = TextProps & {
  isLoading?: boolean;
};

export const Title = ({
  children,
  as = 'h1',
  variant = 'titleSmall',
  isLoading,
  ...rest
}: PageTitleProps) => {
  const pageTitle = usePageTitle();

  return (
    <Text as={as} variant={variant} tabIndex={-1} {...rest}>
      {isLoading ? (
        <Skeleton variant="text" width={300} />
      ) : (
        (children ?? pageTitle)
      )}
    </Text>
  );
};
